import { Component, inject } from '@angular/core';
import { ReleaseService } from '../../changelog/release.service';

@Component({ standalone: false, 
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  private releaseService = inject(ReleaseService);
  public latest: string;

  constructor() {
    this.latest = this.releaseService.getLatestVersion();
  }

  public sidebarData = [
    {
      groupTitle: 'Account',
      groupIcon: 'k-i-user',
      items: [
        { menuTitle: 'Profile', routerLink: 'profile' },
        { menuTitle: 'Environment', routerLink: 'environment' },
        { menuTitle: 'API Keys', routerLink: 'api-keys' },
        { menuTitle: 'Bookmarks', routerLink: 'favorites' },
      ],
    },
    {
      groupTitle: 'Company',
      groupIcon: 'k-i-globe',
      items: [
        { menuTitle: 'Company Information', routerLink: 'company-information' },
        { menuTitle: 'Manage Users', routerLink: 'manage-users' },
      ],
    },
  ];
}
